import assign from 'lodash/assign';
import { user, amber } from './request';
import { getInitFunc } from './gt';

const caches = {};

const getGeetestData = (key, onSuccess, onError, onClose) => {
  const cache = caches[key];

  // if (cache) {
  //     return cache.verify();
  // }

  user
    .post('authcode/geetest3')
    .then((res: any) => {
      // geetConfig
      const { gt, challenge, success } = res.data || {};

      getInitFunc()!(
        {
          gt,
          challenge,
          offline: !success,
          new_captcha: true,
          product: 'bind',
          https: true,
        },
        (captchaObj) => {
          caches[key] = captchaObj;

          captchaObj
            .onReady(() => {
              captchaObj.verify();
              //    此处兼容处理
            })
            .onError(() => {
              captchaObj.reset();
            })
            .onClose(() => {
              onClose && onClose();
            })
            .onSuccess(() => {
              // geetest_challenge:'',
              // geetest_validate:'',
              // geetest_seccode:'',
              // geetest_v:
              const geetestData = captchaObj.getValidate();

              geetestData.geetest_v = '3.0';

              onSuccess(geetestData, captchaObj);
            });
        },
      );
    })
    .catch(() => {
      onError && onError();
    });
};

export default getGeetestData;
